import React from 'react';

const SupportedReports = () => {
  return (
    <table className="supporting-report-formats">
      <thead>
        <tr>
          <td colSpan={4}>
            <h3>
              Annex II: Common tabular formats for the electronic reporting of the information
              necessary to track progress made in implementing and achieving nationally determined
              contributions under Article 4 of the Paris Agreement
            </h3>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Annex II</td>
          <td>Table 1</td>
          <td>Structured Summary: Description of Selected Indicators</td>
          <td>❌ Not supported</td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 2</td>
          <td>Structured Summary: Definitions Needed to Understand NDC</td>
          <td>❌ Not supported</td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 3</td>
          <td>Structured Summary: Methodologies and Accounting Approaches</td>
          <td>❌ Not supported</td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 4</td>
          <td>Structured Summary: Tracking Progress Made in Implementing and Achieving NDC</td>
          <td>❌ Not supported</td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 5</td>
          <td>Structured Summary: Mitigation Co-benefits of Adaptation Actions</td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 6</td>
          <td>Summary of greenhouse gas emissions and removals</td>
          <td>
            ❌ Not supported <span>(Priority for development)</span>
          </td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 7</td>
          <td>
            Information on projections of greenhouse gas emissions and removals under a ‘with
            measures’ scenario
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 8</td>
          <td>
            Information on projections of greenhouse gas emissions and removals under a ‘with
            additional measures’ scenario
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 9</td>
          <td>
            Information on projections of greenhouse gas emissions and removals under a ‘without
            measures’ scenario
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 10</td>
          <td>Projections of key indicators</td>
          <td>
            ❌ Not supported <span>(Priority for development)</span>
          </td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 11</td>
          <td>Key underlying assumptions and parameters used for projections</td>
          <td>
            ❌ Not supported <span>(Priority for development)</span>
          </td>
        </tr>
        <tr>
          <td>Annex II</td>
          <td>Table 12</td>
          <td>
            Information necessary to track progress on the implementation and achievement of the
            domestic policies and measures implemented to address the social and economic
            consequences of response measures
          </td>
          <td>
            ❌ Not supported <span>(Priority for development)</span>
          </td>
        </tr>
      </tbody>
      <thead>
        <tr>
          <td colSpan={4}>
            <h3>
              Annex III: Common tabular formats for the electronic reporting of the information on
              financial, technology development and transfer and capacity-building support provided
              and mobilized, as well as support needed and received, under Articles 9–11 of the
              Paris Agreement
            </h3>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Annex III</td>
          <td>Table 1</td>
          <td>Information on financial support provided- bilateral, regional and other channels</td>
          <td>❌ Not supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 2</td>
          <td>Information on financial support provided- multilateral channels</td>
          <td>❌ Not supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 3</td>
          <td>Information on financial support mobilized through public interventions</td>
          <td>❌ Not supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 4</td>
          <td>
            Information on support for technology development and transfer provided under Article 10
            of the Paris Agreement
          </td>
          <td>❌ Not supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 5</td>
          <td>
            Information on capacity-building support provided under Article 11 of the Paris
            Agreement
          </td>
          <td>❌ Not supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 6</td>
          <td>
            Information on financial support needed by developing country Parties under Article 9 of
            the Paris Agreement
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 7</td>
          <td>
            Information on financial support received by developing country Parties under Article 9
            of the Paris Agreement
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 8</td>
          <td>
            Information on technology development and transfer support needed by developing country
            Parties under Article 10 of the Paris Agreement
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 9</td>
          <td>
            Information on technology development and transfer support received by developing
            country Parties under Article 10 of the Paris Agreement
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 10</td>
          <td>
            Information on capacity-building support needed by developing country Parties under
            Article 11 of the Paris Agreement
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 11</td>
          <td>
            Information on capacity-building support received by developing country Parties under
            Article 11 of the Paris Agreement
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 12</td>
          <td>
            Information on support needed by developing country Parties for the implementation of
            Article 13 of the Paris Agreement and transparency-related activities, including for
            transparency-related capacity-building
          </td>
          <td>✅ Supported</td>
        </tr>
        <tr>
          <td>Annex III</td>
          <td>Table 13</td>
          <td>
            Information on support received by developing country Parties for the implementation of
            Article 13 of the Paris Agreement and transparency-related activities, including for
            transparency-related capacity-building
          </td>
          <td>✅ Supported</td>
        </tr>
      </tbody>
    </table>
  );
};

export default SupportedReports;
